import React from "react";
import Modal from '../../component/Inc/Modal';
function PopAmountEdit(props) {
  const { open, close } = props;
  return (
    <Modal open={open} close={close} type="pop_amount_edit">
      <h2 className='pop_tit'>정산금액 전달</h2>
      <div className="content_container scroll">
        <ul className="com_input_sec">
          <li className="tit_field">지급자 선택</li>
          <li className="input_field">
            <div className="search_wrap com_input_wrap">
              <input type="search" placeholder='교사 검색' className="input s type_search" />
              <button className="com_btn gray s ws icon_search"></button>
            </div>
          </li>
          <li className="tit_field">이전할 금액 입력</li>
          <li className="input_field">
            <input type="text" className="input" placeholder="내용 입력"/>
          </li>
        </ul>
				<div className="com_blue_txt">*이전할 금액에서 지목 수수료는 뺀 금액이 
				전달 됩니다.</div>
      </div>
      <div className="btn_container">
        <button className="com_btn orange xs">변경</button>
      </div>
    </Modal>
  );
}

export default PopAmountEdit;